import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

/**
 * Enforces onboarding routing:
 * - Authenticated users with incomplete onboarding are routed to /onboarding
 * - Completed users are kept out of /onboarding and sent to dashboard
 */
export function OnboardingGuard() {
  const location = useLocation();
  const profile = useAuthStore((s) => s.profile);
  const isLoading = useAuthStore((s) => s.isLoading);

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-[var(--bg-primary)]">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-[var(--color-xp)] border-t-transparent" />
      </div>
    );
  }

  const isOnboardingComplete = profile?.onboarding_completed === true;
  const isOnboardingRoute = location.pathname.startsWith('/onboarding');

  if (!isOnboardingComplete && !isOnboardingRoute) {
    return <Navigate to="/onboarding" replace />;
  }

  if (isOnboardingComplete && isOnboardingRoute) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
